import activeDialogReducer, {MapSceneActiveDialogsReducerState} from './reducers/activeDialogReducer';
import {combineReducers, Reducer} from 'redux';
import generalReducer, {MapSceneGeneralReducerState} from './reducers/generalReducer';
import filterAndSearchReducer, {MapSceneFilterAndSearchReducerState} from './reducers/filterAndSearchReducer';
import trafficInformationReducer, {MapSceneTrafficInformationReducerState} from './reducers/trafficInformationReducer';
import mapLayersReducer, {MapSceneMapLayersReducerState} from './reducers/mapLayersReducer';
import dataReducer, {MapSceneDataSourcesReducerState} from './reducers/dataReducer';

export interface MapSceneCombinedReducerState {
    activeDialogs: MapSceneActiveDialogsReducerState;
    filterAndSearch: MapSceneFilterAndSearchReducerState;
    general: MapSceneGeneralReducerState;
    mapLayers: MapSceneMapLayersReducerState;
    data: MapSceneDataSourcesReducerState;
    trafficInformation: MapSceneTrafficInformationReducerState;
}

const mapSceneCombinedReducer: Reducer<MapSceneCombinedReducerState> = combineReducers<MapSceneCombinedReducerState>({
    activeDialogs: activeDialogReducer,
    filterAndSearch: filterAndSearchReducer,
    general: generalReducer,
    mapLayers: mapLayersReducer,
    data: dataReducer,
    trafficInformation: trafficInformationReducer,
});

export default mapSceneCombinedReducer;
